import React, { useEffect, useMemo, useState } from 'react'
import { MainWrapper } from '../component/MainWrapper'
import { Button } from 'sr/helpers';
import DropDown from 'sr/helpers/ui-components/DropDown.tsx';
import { Link, useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { getJobs } from 'sr/utils/api/cleaner/jobs/getJobs';
import Job from 'app/pages/component/types/Job';
import { getApplication } from 'sr/utils/api/cleaner/getApplication';
import { DateFormat } from 'sr/helpers/functions/DateFormat';
import { SocialShare } from 'app/pages/component/SocialShare';
import ContentWithSpinner from 'sr/layout/common/ContentWithSpiner';
import { jobStatus, payTypes } from "sr/i18n/messages/setting";
import { updateBasicDetails } from "sr/utils/api/cleaner/company/jobPost/updateBasicDetails";
import { getJobTypeCategory } from 'sr/utils/api/getJobTypeCategory';
import getLabelByValue from 'sr/helpers/functions/getLabelByValue';
import { SuccessMessage } from 'sr/helpers/functions/SuccessMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { benifitdata, employment, Schedule, supplementalpaydata } from '../jobpost/component/Jsonalldata';
import { formatNumberWithCommas } from 'sr/helpers/functions/formatNumber';
import moment from 'moment';
import { getGeneralType } from 'sr/utils/api/getGeneralType';
import { TrainingCertificationRequirementWarning } from 'sr/helpers/ui-components/company/TrainingCertificationRequirementWarning';
import { RegionChips } from "sr/helpers/ui-components/RegionChips";

export const PostedJobDetails = () => {
  const [id, setId] = useState('')
  const [job, setJob] = useState<Job | null>(null);
  const [applicant, setApplicant] = useState<[]>()
  const [candidateCount, setCandidateCount] = useState<{}>({})
  const [totalCandidate, setTotalCandidate] = useState(null)
  const [loader, setLoader] = useState(false)
  const [trainingLabelsById, setTrainingLabelsById] = useState<Record<string, string>>({})
  const [certificationLabelsById, setCertificationLabelsById] = useState<Record<string, string>>({})
  const param = useParams()
const [jobTypes, setJobTypes] = useState([])
    useEffect(()=>{
      const fetchJobType = async ()=>{
try {
const res = await getJobTypeCategory()
if(res?.success===true){
  setJobTypes(res?.data)
}
}
catch(e:any){

}
      }
      fetchJobType()
    },[])

  useEffect(() => {
    const mapLabels = (items: any[] = []) => {
      const entries = items
        .map((item) => [String(item?._id || item?.id || ""), String(item?.title || "")] as const)
        .filter(([key, val]) => key && val);
      return Object.fromEntries(entries);
    };

    const fetchTrainingCertificationLabels = async () => {
      try {
        const [trainingResponse, certificationResponse] = await Promise.all([
          getGeneralType("cleanerTrainings"),
          getGeneralType("cleanerCertifications"),
        ]);
        setTrainingLabelsById(mapLabels(trainingResponse?.data || []));
        setCertificationLabelsById(mapLabels(certificationResponse?.data || []));
      } catch (e: any) {}
    };

    fetchTrainingCertificationLabels();
  }, []);
  useEffect(()=> {
    const {id} = param
    setId(id)
  },[])
  useEffect(()=> {
    const fetchJob = async ()=> {
      try {
      setLoader(true)
      const queryParams = new URLSearchParams();  
      if (id) queryParams.append('id', id.toString());
      const result = await getJobs(queryParams)
      if(result.success===true) {
          const queryParams = new URLSearchParams();
          queryParams.append('job_id', id.toString());
        const resultC = await getApplication(queryParams)
        if(resultC) {
            setApplicant(resultC?.data)
            setCandidateCount(resultC?.pagination?.statusCounts)
            setLoader(false)
        }
      setJob(result?.data)
      }
      else {
        setLoader(false)
      }
    } catch(error) {
      setLoader(false)
    }
    }
    if(id) {
    fetchJob()
    }
  },[id])
  const intl = useIntl()
  const JobDescriptionComponent = ({ jobDescription }) => {
    return (
      <div className='job-description' dangerouslySetInnerHTML={{ __html: jobDescription }} />
    );
  };

  useEffect(()=> {
    const countsArray = Object.values(candidateCount);
    const sum = countsArray.reduce((accumulator:number, currentValue:number) => accumulator + currentValue, 0);
    setTotalCandidate(sum)
  },[candidateCount])
  
  const HandleJobStatus = async (e: any) => {
    const data = {
      id: id,
      status: e.target.value,
    };
    const res = await updateBasicDetails(data);
    if (res.success === true) {
      setJob(res?.data);
      SuccessMessage('API.SUCCESS.JOB.POST.STATUS')
    }
  };

  const path = `/job-detail/${id}`
  const fullLink = `https://${process.env.REACT_APP_BASE_URL}${path}`
  const addressLine1 = job?.job_advanced_id?.reporting_address?.address_line_1;
  const addressLine2 = job?.job_advanced_id?.reporting_address?.address_line_2;
  const city = job?.job_advanced_id?.reporting_address?.city;

  const additionalRegionIds = useMemo(() => {
    const raw = (job as any)?.job_advanced_id?.reporting_regions;
    if (!Array.isArray(raw)) return [];
    return raw
      .map((r: any) => String(r?.id || r?._id || r || ""))
      .filter(Boolean);
  }, [(job as any)?.job_advanced_id?.reporting_regions]);

  function FloatI(value) {
    const num = parseFloat(value);
    return Number.isInteger(num) ? num.toFixed(2) : String(num);
  }

  return (
    <MainWrapper>
      <ContentWithSpinner loader={loader} height='h-screen'>
      <div className='py-3'>
    <div className='grid grid-cols-12 gap-4'>
   <div className='col-span-9 bg-white rounded-[20px] p-6'>
  <Link to='/jobs-listing' className='flex items-center text-[#0078ae]  space-x-2'>
<svg xmlns="http://www.w3.org/2000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-6 h-6"><path d="M21 11.5a.5.5 0 00-.5-.5H6.622l3.598-3.598a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0l-5.659 5.658a.498.498 0 000 .708l5.659 5.658a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L6.622 13H20.5a.5.5 0 00.5-.5v-1z"></path></svg>
<span className='text-sm font-bold'>
  <FormattedMessage
    id='RECRUITER.POSTED.JOB.DETAILS.BACK.BUTTON'
    defaultMessage='Back to jobs'
  />
</span>

</Link>
<div className='flex items-center justify-between py-3'>
  <div>
  <h1 className='text-2xl '>{job?.job_title}</h1>
  <p>{addressLine1}{addressLine1 ? "," : ""} {addressLine2}{addressLine2 ? "," : ""} {city}</p>
  {additionalRegionIds.length ? (
    <div className="mt-2">
      <p className="text-sm font-medium text-gray-700">
        <FormattedMessage
          id="RECRUITER.POSTJOB.ADVANCEDETAILS.REPORTING.REGIONS"
          defaultMessage="Additional Regions"
        />
      </p>
      <div className="mt-2 flex flex-wrap gap-2">
        <RegionChips regionIds={additionalRegionIds} />
      </div>
    </div>
  ) : null}
  </div>

    </div>
    <hr  className='border border-neutral-200 mb-3'/>
    <div className=''>
      <div>
      <h2 className='text-xl  mb-3'> <FormattedMessage id="RECRUITER.POSTED.JOB.CANDIDATES.TITLE" defaultMessage="Candidates" />  </h2>
<div className='flex items-center justify-center space-x-6'>
<Button className=' capitalize text-[#0078ae] w-full justify-center'
       hovertext = 'hover:text-[#0078ae]'
       color = 'neutral-200'
       bordersize='border'>
          <Link to={`/candidates/awaiting-reviews/${job?.id}`}>
        <div className='my-3'>
        <p><FormattedMessage id="RECRUITER.POSTED.JOB.CANDIDATES.AWAITING.REVIEWS" defaultMessage="Awaiting Reviews" />  </p>
       <span className='text-2xl font-bold'>{ candidateCount && candidateCount['awaiting-reviews'] || 0}</span>
       </div>
       </Link>
       </Button>
      
       <Button className=' w-full capitalize text-[#0078ae] justify-center'
       hovertext = 'hover:text-[#0078ae]'
       color = 'neutral-200'
       bordersize='border'
       >
              <Link to={`/candidates/active/${job?.id}`}>
        <div className='my-3'>
       <p><FormattedMessage id="RECRUITER.POSTED.JOB.CANDIDATES.TOTAL.TITLE" defaultMessage="Total (Excluding Rejected)" /></p>
      <span className='text-2xl '>{totalCandidate || 0}</span>
      </div>
      </Link></Button>
</div>

      </div>
      <div className='mt-3'>

                  {(job?.exact_amount || job?.min_amount || job?.max_amount) && (
                    <>
                      <hr className="border border-neutral-200 mb-3 mt-6" />
                      <h2 className="text-xl mb-3">Rate</h2>
                      <div className="flex items-center">
                        {job?.exact_amount ? (
                          <>
                            <FontAwesomeIcon icon={faDollarSign} className="text-[14px] mr-[2px]" />
                            <span className="font-bold mr-1">{FloatI(job.exact_amount)}</span> {<FormattedMessage id={getLabelByValue(job.rate, payTypes)} />}
                          </>
                        ) : job?.min_amount && job?.max_amount ? (
                          <>
                            <FontAwesomeIcon icon={faDollarSign} className="text-[14px] mr-[2px]" />
                            <span className="font-bold">{FloatI(job.min_amount)}</span> - <span className="font-bold mr-1">{FloatI(job.max_amount)}</span> {<FormattedMessage id={getLabelByValue(job.rate, payTypes)} />}
                          </>
                        ) : job?.min_amount ? (
                          <>
                            Starting from&nbsp;
                            <FontAwesomeIcon icon={faDollarSign} className="text-[14px] mr-[2px]" />
                            <span className="font-bold mr-1">{FloatI(job.min_amount)}</span> {<FormattedMessage id={getLabelByValue(job.rate, payTypes)} />}
                          </>
                        ) : (
                          <>
                            Upto&nbsp;
                            <FontAwesomeIcon icon={faDollarSign} className="text-[14px] mr-[2px]" />
                            <span className="font-bold mr-1">{FloatI(job.max_amount)}</span> {<FormattedMessage id={getLabelByValue(job.rate, payTypes)} />}
                          </>
                        )}
                      </div>
                      <hr className="border border-neutral-200 my-3" />
                    </>
                  )}


        <h1 className='text-xl mb-3'><FormattedMessage id="JOBDETAILS.JOBDESCRIPTION" defaultMessage="Job Description" /></h1>
        <JobDescriptionComponent jobDescription={job?.job_description} />
        <br />
        <div className='mt-3 flex space-x-2'>
                                    <h3 className='font-bold  text-base whitespace-nowrap'>   <FormattedMessage 
                                    id='JOBDETAILS.HIGHLIGHT.BENIFITS'
                                    defaultMessage='Benefits'
                                    />:</h3>
                                     <div className='flex flex-wrap'>
                                   {job?.benefits?.map((item, index) => (
  <span key={index}>
    <FormattedMessage id={getLabelByValue(item, benifitdata)} />
    {index !== job?.benefits?.length - 1 && <span>,&nbsp;</span>}
  </span>
))}

                                 </div>
                                    
                                </div>
                                <div className='mt-3 flex space-x-2'>
                                    <h3 className='font-bold  text-base whitespace-nowrap'>   <FormattedMessage 
                                    id='JOBDETAILS.HIGHLIGHT.JOBTYPE'
                                    defaultMessage='Job Type'
                                    />: </h3>
                                        <div className='flex flex-wrap'>
                                    {job?.job_type?.map((item,index )=> (
                                        <div className='mr-2' key={index}><FormattedMessage id={getLabelByValue(item, jobTypes)}></FormattedMessage>{index < job?.job_type?.length - 1 && ','}</div>
                                 )   )}
                                    </div>
                                </div>
                                <div className='mt-3 flex space-x-2'>
                                    <h3 className='font-bold  text-base whitespace-nowrap'>   <FormattedMessage 
                                    id='JOBDETAILS.HIGHLIGHT.EMPLOYMENTTYPE'
                                    defaultMessage='Employment Type'
                                    />: </h3>
                                       <div className='flex flex-wrap'>
                                                                     {job?.employment_type?.map((item, index) => (
  <span key={index}>
    <FormattedMessage id={getLabelByValue(item, employment)} />
    {index !== job?.employment_type?.length - 1 && <span>,&nbsp;</span>}
  </span>
))}
                                    </div>
                                </div>
                                <div className='mt-3 flex space-x-2'>
                                    <h3 className='font-bold  text-base whitespace-nowrap'>   <FormattedMessage 
                                    id='JOBDETAILS.HIGHLIGHT.SCHEDULE'
                                    defaultMessage='Schedule'
                                    />: </h3>
                                     <div className='flex flex-wrap'>
                                                                    {job?.schedule?.map((item, index) => (
  <span key={index}>
    <FormattedMessage id={getLabelByValue(item, Schedule)} />
    {index !== job?.schedule?.length - 1 && <span>,&nbsp;</span>}
  </span>
))}
                                </div>

                                 
                                    
                                </div>
                                <div className='mt-3 flex space-x-2'>
                                    <h3 className='font-bold  text-base whitespace-nowrap'>   <FormattedMessage 
                                    id='JOBDETAILS.SUPPLEMENTALPAY'
                                    defaultMessage='Supplemental Pay'
                                    />: </h3>
                                     <div className='flex flex-wrap'>
                                    {job?.supplemental_pay?.map((item, index) => (
  <span key={index}>
    <FormattedMessage id={getLabelByValue(item, supplementalpaydata)} />
    {index !== job?.supplemental_pay?.length - 1 && <span>,&nbsp;</span>}
  </span>
))}

                                 </div></div>
                                {typeof job?.require_certification_training === "boolean" && (
                                  <div className='mt-3'>
                                    <p className='text-base'>
                                      <span className='font-bold'>
                                        <FormattedMessage
                                          id='JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.TITLE'
                                          defaultMessage='Any required trainings or certifications'
                                        />
                                      </span>
                                      :{" "}
                                      {job?.require_certification_training ? (
                                        <FormattedMessage
                                          id='JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.YES'
                                          defaultMessage='Yes'
                                        />
                                      ) : (
                                        <FormattedMessage
                                          id='JOBDETAILS.REQUIRED.TRAINING_CERTIFICATION.NO'
                                          defaultMessage='No'
                                        />
                                      )}
                                    </p>

                                    {job?.require_certification_training && (
                                      <div className="mt-4 rounded-lg border border-neutral-200 bg-white p-4">
                                        {(job?.trainings?.length || 0) > 0 && (
                                          <div className={`${(job?.certifications?.length || 0) > 0 ? "pb-4 border-b border-neutral-200" : ""}`}>
                                            <h4 className="text-base font-bold">Training</h4>
                                            <p className="mt-2">
                                              {job?.trainings
                                                ?.map((item) => trainingLabelsById?.[String(item)] || String(item))
                                                .join(", ")}
                                            </p>
                                          </div>
                                        )}

                                        {(job?.certifications?.length || 0) > 0 && (
                                          <div className={`${(job?.trainings?.length || 0) > 0 ? "pt-4" : ""}`}>
                                            <h4 className="text-base font-bold">Certification</h4>
                                            <p className="mt-2">
                                              {job?.certifications
                                                ?.map((item) => certificationLabelsById?.[String(item)] || String(item))
                                                .join(", ")}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {job?.require_certification_training &&
                                      (((job?.trainings?.length || 0) > 0) || ((job?.certifications?.length || 0) > 0)) && (
                                        <TrainingCertificationRequirementWarning />
                                      )}
                                  </div>
                                )}
      </div>
    </div>
   </div>

   <div className='col-span-3 bg-white rounded-[20px] p-5 h-fit'>
<div className='flex'>
   <Link className="text-center w-full rounded-lg font-bold bg-[#ff39b3] px-5 py-2  text-white cursor-pointer hover:bg-navy" to={`/job-post/review/${job?.id}`}>{intl.formatMessage({id:'RECRUITER.POSTED.JOB.ACTION.EDITJOB', defaultMessage:'Edit Job'})}</Link>
   </div>
   <DropDown
      onChange={HandleJobStatus}
      value={job?.status}
      dropdowndiv="my-3"
      label={intl.formatMessage({
        id: "RECRUITER.POSTED.JOB.JOBSTATUS.TITLE",
        defaultMessage: "Job Status",
      })}
      labelMargin="mb-1"
      className="rounded-lg"
    >
      {jobStatus.map((item, index) => (
        <option key={index} value={item?.value}>
          {" "}
          {item?.label}
        </option>
      ))}
    </DropDown>
        <Link target="_blank" to={`/job-detail/${id}`}>
    <Button className=' capitalize text-[#0078ae] w-full justify-center'
       hovertext = 'hover:text-[#0078ae]'
       color = 'neutral-200'
       bordersize='border'
       ><FormattedMessage
       id="RECRUITER.POSTED.JOB.VIEWPUBLICPAGE.BUTTON"
       defaultMessage="View Public Job Page"
     /></Button>
     </Link>
       <hr  className='border border-neutral-200 my-5'/>
       <div className='mb-5'>
        <h2 className=' mb-4'><FormattedMessage id='RECRUITER.POSTED.JOB.DETAILS.TITLE' defaultMessage='Details' /></h2>
        <p className='mb-1'><span className=' text-[#424242]'><FormattedMessage id='RECRUITER.POSTED.JOB.POSTED.TIME.TITLE' defaultMessage='Posted' />:</span> {DateFormat(job?.createdAt)} </p>
        <p className='mb-1'><span className=' text-[#424242]'><FormattedMessage  id='RECRUITER.POSTED.JOB.DETAILS.CANDIDATES' defaultMessage='Candidates'/>:</span><Link className='text-[#0078ae] font-bold' to={`/candidates/job/${job?.id}`}> {applicant?.length} </Link></p>
       {job?.job_advanced_id?.recruitment_timeline &&
        <p className='mb-1'>
        <span className=' text-[#424242]'>Accepting Applications Until: </span>
       <span>{DateFormat(job?.job_advanced_id?.application_deadline)}</span>
       </p>
}
{job?.job_advanced_id?.recruitment_timeline &&
       <p className='mb-1'>
        <span className=' text-[#424242]'>Position Needs Filled By: </span>
       <span>{moment(job?.job_advanced_id?.recruitment_timeline).format('MM/DD/YYYY')}</span>
       </p>
}
       </div>
       {/* <Button className=' capitalize text-[#0078ae] w-full justify-center'
       hovertext = 'hover:text-[#0078ae]'
       color = 'neutral-200'
       bordersize='border'
       > <FormattedMessage id="RECRUITER.POSTED.JOB.DETAILS.ADD_A_CANDIDATE.BUTTON" defaultMessage="Add A Candidate" />  </Button> */}
        {/* <hr className='border border-neutral-200 my-5' /> */}
        {/* <div className='mb-5'>
        <h2 className=' mb-4'><FormattedMessage id="RECRUITER.POSTED.JOB.BUDGET.TITLE" defaultMessage="Budget" /></h2>
        <p className='mb-1'><span className=' text-[#424242]'><FormattedMessage id="RECRUITER.POSTED.JOB.JOB.BUDGET.TITLE" defaultMessage="Job Budget" />:</span>  <FormattedMessage id="RECRUITER.POSTED.JOB.JOB.BUDGET.VALUE" defaultMessage="Not sponsered" />  </p>
       </div> */}
       {/* <Button className=' capitalize text-[#0078ae] w-full justify-center'
       hovertext = 'hover:text-[#0078ae]'
       color = 'neutral-200'
       bordersize='border'
       > <FormattedMessage id="RECRUITER.POSTED.JOB.BUDGET.SPONSER_NOW.BUTTON" defaultMessage="Sponsor Now" />  </Button> */}
        <hr  className='border border-neutral-200 my-5'/>
        <div>
          <div className='w-full text-center'>
          <FormattedMessage id="RECRUITER.POSTED.JOB.BUDGET.SUGGESTED_TEXT" defaultMessage="Promote this job for more candidates:" />
          <div className='flex space-x-2 my-4 justify-center items-center'>
                                  <SocialShare fullLink={fullLink} title={job?.job_title}/>
          </div>
        </div></div>
   </div>
    </div>
    </div>
    </ContentWithSpinner>
    </MainWrapper>
  )
}
